import { createSelector } from 'reselect'
import emptyMediaSlide from 'helpers/media_slide/empty_media_slide'
import { convertToMinutesAndSeconds } from 'helpers/convertToMinutesAndSeconds'
import getAssetById from 'redux/selectors/assets/asset_selector'
import mediaTypes from 'helpers/enums/mediaTypes'

const getMediaSlidesData = state => state.mediaSlides

const mediaSlide = createSelector(
	[ getMediaSlidesData, getAssetById ],
	(mediaSlides, getAsset) => lessonUid => {
		const media = mediaSlides.find(slide => slide.lessonUid === lessonUid)
		if (media) {
			const durationFormatted = `${convertToMinutesAndSeconds(media.trimEnd - media.trimStart)}`
			const videoAsset = media.asset
				&& Object.keys(media.asset).length ? getAsset(media.asset.uid, mediaTypes.VIDEO) : {}
			return {
				...media,
				duration: durationFormatted,
				handouts: media.handouts
					? media.handouts.map(handout => (
						{...handout, asset: getAsset(handout.assetUid, mediaTypes.BINARY)}
					))
					: [],
				source: videoAsset.versions ? videoAsset.versions[0].source : '',
			}
		} else {
			return emptyMediaSlide
		}
	}
)

export default mediaSlide
